import React, { ChangeEvent } from 'react';
import { TeacherApplicationForm } from '../../model/TeacherApplicationForm';
import { validateQualifications, validateEmployment } from '../../utils/teacherApplicationValidators';

interface ProfessionalInfoStepProps {
  formData: TeacherApplicationForm;
  setFormData: (data: TeacherApplicationForm) => void;
  errors: { [key: string]: string };
  setErrors: (errors: { [key: string]: string }) => void;
}

const ProfessionalInfoStep: React.FC<ProfessionalInfoStepProps> = ({ formData, setFormData, errors, setErrors }) => {
  const handleTextChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Real-time validation
    let error = '';
    if (name === 'qualifications') {
      error = validateQualifications(value);
    } else if (name === 'current_employment') {
      error = validateEmployment(value);
    }

    setErrors({ ...errors, [name]: error });
  };

  const handleCarChange = (value: boolean) => {
    setFormData({ ...formData, has_car: value });
    setErrors({ ...errors, has_car: '' });
  };

  return (
    <div className="space-y-6">
      {/* Has Car */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">Possiedi un'auto?</label>
        <div className="flex gap-4">
          <button
            type="button"
            onClick={() => handleCarChange(true)}
            className={`flex-1 py-3 px-6 rounded-lg border-2 font-medium transition-all ${
              formData.has_car === true
                ? 'border-fpcred bg-fpcred text-white'
                : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400'
            }`}>
            Sì
          </button>
          <button
            type="button"
            onClick={() => handleCarChange(false)}
            className={`flex-1 py-3 px-6 rounded-lg border-2 font-medium transition-all ${
              formData.has_car === false
                ? 'border-fpcred bg-fpcred text-white'
                : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400'
            }`}>
            No
          </button>
        </div>
        {errors.has_car && <p className="mt-1 text-sm text-red-500">{errors.has_car}</p>}
      </div>

      {/* Qualifications */}
      <div>
        <label htmlFor="qualifications" className="block text-sm font-medium text-gray-700 mb-2">
          Qualifiche e Titoli di Studio <span className="text-red-500">*</span>
        </label>
        <textarea
          id="qualifications"
          name="qualifications"
          rows={2}
          placeholder="Es. Laurea in Matematica presso Università di Bologna, Master in Didattica..."
          value={formData.qualifications}
          onChange={handleTextChange}
          required
          className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-fpcred focus:border-transparent resize-none ${
            errors.qualifications ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {errors.qualifications && <p className="mt-1 text-sm text-red-500">{errors.qualifications}</p>}
      </div>

      {/* Current Employment */}
      <div>
        <label htmlFor="current_employment" className="block text-sm font-medium text-gray-700 mb-2">
          Occupazione Attuale <span className="text-red-500">*</span>
        </label>
        <textarea
          id="current_employment"
          name="current_employment"
          rows={2}
          placeholder="Es. Insegnante presso Liceo Scientifico, Libero professionista, Studente universitario..."
          value={formData.current_employment}
          onChange={handleTextChange}
          required
          className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-fpcred focus:border-transparent resize-none ${
            errors.current_employment ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {errors.current_employment && <p className="mt-1 text-sm text-red-500">{errors.current_employment}</p>}
      </div>
    </div>
  );
};

export default ProfessionalInfoStep;
